import React, { useState, useEffect } from "react";
import RequestHandler from "util/RequestHandler";
import { ColumnHelper } from "util/TableHelper";
import moment from "moment";

import {
  Table,
  Empty,
  Popconfirm,
  Col,
  Row,
  Drawer,
  Button,
  Popover,
  Tabs,
  Tooltip,
  notification,
} from "antd";
import {
  BarsOutlined,
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  InfoCircleOutlined,
  WarningOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";

import PosCollectionCommissionDefinitionTableFilter from "../Filters/PosCollectionCommissionDefinitionTableFilter";
import PosCollectionCommissionDefinitionAddForm from "../Forms/PosCollectionCommissionDefinitionAddForm";
import PosCollectionCommissionDefinitionUpdateForm from "../Forms/PosCollectionCommissionDefinitionUpdateForm";

const PosCollectionCommissionDefinition = () => {
  const [tableData, setTableData] = useState({
    data: [],
    total: 0,
    loading: true,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState({
    skip: 0,
    take: 15,
    current: 1,
    filter: "",
    activeTab: 0,
  });

  const [addFormVisibility, setAddFormVisibility] = useState(false);
  const [updateFormVisibility, setUpdateFormVisibility] = useState(false);
  const [updateFormData, setUpdateFormData] = useState({});
  const [tabKeyValue, setTabKeyValue] = useState("0");
  const [tabData, setTabData] = useState([]);

  useEffect(() => getTableData(), [tableDataQueryOptions]);
  useEffect(() => getTabs(), []);

  const getTabs = () => {
    // Backend'den veri listesini alın ve state'i güncelleyin.
    RequestHandler.get(`/PosCollectionCommissionDefinition/GetListTabs`).then(
      (response) => {
        if (response) {
          setTabData(response);
        }
      }
    );
  };

  const getTableData = () => {
    setTableData({
      ...tableData,
      loading: true,
    });

    let query = "";
    const { skip, take, filter, activeTab } = tableDataQueryOptions;

    const conditions = [];

    if (filter && tabKeyValue === "0") {
      conditions.push(filter);
    }

    if (tabKeyValue !== "0") {
      conditions.push(
        `bankId eq ${tabData.find((x) => x.key == tabKeyValue).bankId}`
      );
    }

    if (conditions.length > 0) {
      query = `&$filter=${conditions.join(" and ")}`;
    }

    RequestHandler.get(
      `/PosCollectionCommissionDefinition?$count=true${query}&$skip=${skip}&$top=${take}`
    ).then((response) => {
      setTableData({
        data: response.value,
        total: response["@odata.count"],
        loading: false,
      });
    });
  };

  const getUpdateFormData = (id) => {
    RequestHandler.get(`/PosCollectionCommissionDefinition/GetById/${id}`).then(
      (response) => {
        if (response) {
          response.validityDate = [
            moment(response.validityStartDate),
            moment(response.validityEndDate),
          ];
          setUpdateFormData(response);
          setUpdateFormVisibility(true);
        }
      }
    );
  };

  const paging = (p) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };

  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      skip: 0,
      current: 1,
      take: tableDataQueryOptions.take,
      filter: "",
    });
  };

  const onFinishTableFilter = (query) => {
    setTableDataQueryOptions((prevState) => {
      return { skip: 0, current: 1, take: prevState.take, filter: query };
    });
  };

  const handleOnClickDelete = (id) => {
    RequestHandler.delete(`/PosCollectionCommissionDefinition/${id}`).then(
      (response) => {
        if (response?.success) {
          getTableData();
        }
      }
    );
  };

  const onAddFormSuccess = () => {
    getTableData();
    setAddFormVisibility(false);
  };

  const onUpdateFormSuccess = () => {
    getTableData();
    setUpdateFormVisibility(false);
  };
  const renderCommissionRate = (data, record, includedKey) => {
    return data || data === 0 ? (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 4,
          marginLeft: "10px",
        }}
      >
        {ColumnHelper.renderDecimal(data)}
        {record[includedKey] && (
          <Tooltip title="KTD">
            <CheckCircleOutlined style={{ color: "#1890ff" }} />
          </Tooltip>
        )}
      </div>
    ) : (
      "-"
    );
  };

  const columns = [
    {
      title: "Banka",
      dataIndex: "bankLogo",
      key: "bankLogo",
      width: "8%",
      render: (data) => <img src={data}></img>,
    },
    {
      title: "Kart", // Buraya kart logo indexi gelecek
      dataIndex: "cardLogo",
      key: "cardLogo",
      width: "8%",
      render: (data, row) =>
        row.bankId === 889 || row.bankId === 890 ? (
          row.cardLogo === null ? (
            <p style={{ paddingTop: "inherit" }}>{row.cardName}</p>
          ) : (
            <img src={data} height={35} width={102}></img>
          )
        ) : (
          <img src={data}></img>
        ),
    },
    {
      title: "Tanımlama Adı",
      dataIndex: "posCollectionBankInfoName",
    },
    {
      title: "Artı Taksit Sayısı",
      dataIndex: "extraInstallmentCount",
      align: "center",
      render: (data) => (data === 0 ? "-" : data),
    },
    {
      title: "Erteleme Taksit Sayısı",
      dataIndex: "deferringInstallmentCountString",
      align: "center",
      render: (data) => (data === null ? "-" : data),
    },
    {
      title: "Kampanya Bitiş Tarihi",
      dataIndex: "extraInstallmentExpireDate",
      align: "center",
      render: (data) => (data ? moment(data).format("L") : "-"),
    },
    {
      title: "Tek Çekim",
      dataIndex: "commissionRate1",
      align: "center",
      render: (data, record) =>
        renderCommissionRate(
          data,
          record,
          "isCommissionIncludedCommissionRate1"
        ),
    },
    {
      title: "2 Taksit",
      dataIndex: "commissionRate2",
      align: "center",
      render: (data, record) =>
        renderCommissionRate(
          data,
          record,
          "isCommissionIncludedCommissionRate2"
        ),
    },
    {
      title: "3 Taksit",
      dataIndex: "commissionRate3",
      align: "center",
      render: (data, record) =>
        renderCommissionRate(
          data,
          record,
          "isCommissionIncludedCommissionRate3"
        ),
    },
    {
      title: "4 Taksit",
      dataIndex: "commissionRate4",
      align: "center",
      render: (data, record) =>
        renderCommissionRate(
          data,
          record,
          "isCommissionIncludedCommissionRate4"
        ),
    },
    {
      title: "5 Taksit",
      dataIndex: "commissionRate5",
      align: "center",
      render: (data, record) =>
        renderCommissionRate(
          data,
          record,
          "isCommissionIncludedCommissionRate5"
        ),
    },
    {
      title: "6 Taksit",
      dataIndex: "commissionRate6",
      align: "center",
      render: (data, record) =>
        renderCommissionRate(
          data,
          record,
          "isCommissionIncludedCommissionRate6"
        ),
    },
    {
      title: "7 Taksit",
      dataIndex: "commissionRate7",
      align: "center",
      render: (data, record) =>
        renderCommissionRate(
          data,
          record,
          "isCommissionIncludedCommissionRate7"
        ),
    },
    {
      title: "8 Taksit",
      dataIndex: "commissionRate8",
      align: "center",
      render: (data, record) =>
        renderCommissionRate(
          data,
          record,
          "isCommissionIncludedCommissionRate8"
        ),
    },
    {
      title: "9 Taksit",
      dataIndex: "commissionRate9",
      align: "center",
      render: (data, record) =>
        renderCommissionRate(
          data,
          record,
          "isCommissionIncludedCommissionRate9"
        ),
    },
    {
      title: "10 Taksit",
      dataIndex: "commissionRate10",
      align: "center",
      render: (data, record) =>
        renderCommissionRate(
          data,
          record,
          "isCommissionIncludedCommissionRate10"
        ),
    },
    {
      title: "11 Taksit",
      dataIndex: "commissionRate11",
      align: "center",
      render: (data, record) =>
        renderCommissionRate(
          data,
          record,
          "isCommissionIncludedCommissionRate11"
        ),
    },
    {
      title: "12 Taksit",
      dataIndex: "commissionRate12",
      align: "center",
      render: (data, record) =>
        renderCommissionRate(
          data,
          record,
          "isCommissionIncludedCommissionRate12"
        ),
    },
    {
      title: "Açıklama",
      dataIndex: "description",
      align: "center",
      render: (data) =>
        data ? (
          <Popover content={data}>
            <a>
              <InfoCircleOutlined style={{ fontSize: "130%" }} />
            </a>
          </Popover>
        ) : undefined,
    },
    {
      title: "Durum",
      dataIndex: "id",
      align: "center",
      render: (data, row) =>
        row.isActive ? (
          <Popconfirm
            title="Pasif yapmak istiyor musunuz?"
            okText="Evet"
            cancelText="Hayır"
            onConfirm={() => handleActivePassive(data)}
          >
            <a style={{ color: "green", fontSize: "130%" }}>
              <CheckCircleOutlined />
            </a>
          </Popconfirm>
        ) : (
          <Popconfirm
            title="Aktif yapmak istiyor musunuz?"
            okText="Evet"
            cancelText="Hayır"
            onConfirm={() => handleActivePassive(data)}
          >
            <a style={{ color: "red", fontSize: "130%" }}>
              <CloseCircleOutlined />
            </a>
          </Popconfirm>
        ),
    },
    {
      title: (
        <span>
          Otomatik Güncelleme &nbsp;
          <Tooltip
            placement="top"
            title="Bazı ödeme kuruluşları, komisyon oranlarını servis üzerinden dinamik olarak iletmektedir. Bu özellik, yalnızca Otomatik Güncelleme seçeneği aktif olan tanımlamalar için geçerlidir. Komisyon oranlarını manuel olarak yönetmeyi tercih ederseniz, bu özelliği pasif konuma getirebilirsiniz. Özellik aktif kaldığı sürece, manuel değişiklikleriniz sistem tarafından otomatik verilerle güncellenmeye devam edecektir."
            overlayStyle={{ maxWidth: "300px" }}
          >
            <InfoCircleOutlined style={{ color: "#1890ff", cursor: "help" }} />
          </Tooltip>
        </span>
      ),
      dataIndex: "id",
      align: "center",
      render: (data, row) => {
        const autoUpdateBanks = [889, 890, 856, 857];
        const isAutoUpdateEligible = autoUpdateBanks.includes(row.bankId);

        if (!isAutoUpdateEligible) {
          return "-";
        }

        return row.isEnabledAutoUpdate ? (
          <Popconfirm
            title="Otomatik güncellemeyi kapatmak istiyor musunuz?"
            okText="Evet"
            cancelText="Hayır"
            onConfirm={() => handleToggleAutoUpdate(data, false)}
          >
            <a style={{ color: "green", fontSize: "130%" }}>
              <CheckCircleOutlined />
            </a>
          </Popconfirm>
        ) : (
          <Popconfirm
            title="Otomatik güncellemeyi açmak istiyor musunuz?"
            okText="Evet"
            cancelText="Hayır"
            onConfirm={() => handleToggleAutoUpdate(data, true)}
          >
            <a style={{ color: "red", fontSize: "130%" }}>
              <CloseCircleOutlined />
            </a>
          </Popconfirm>
        );
      },
    },
    {
      title: "Düzenle",
      dataIndex: "id",
      width: "1%",
      align: "center",
      render: (data, row) =>
        row.isActive ? (
          <a onClick={() => getUpdateFormData(data)}>
            <EditOutlined style={{ color: "orange", fontSize: "130%" }} />
          </a>
        ) : (
          <a
            onClick={() => {
              openNotificationWithIcon("warning");
            }}
            style={{
              color: "orange",
              fontSize: "130%",
              paddingBottom: "20px",
            }}
          >
            <EditOutlined />
          </a>
        ),
    },
    {
      title: "Sil",
      dataIndex: "id",
      width: "1%",
      align: "center",
      render: (data, row) =>
        row.bankId === 889 ||
        row.bankId === 890 ||
        row.bankId === 856 ||
        row.bankId == 857 ? (
          <Tooltip
            title={`${row.bankName} komisyon oranları otomatik olarak servislerden alınmaktadır.`}
          >
            <WarningOutlined style={{ color: "orange", fontSize: "130%" }} />
          </Tooltip>
        ) : (
          <Popconfirm
            title="Silmek istiyor musunuz?"
            okText="Evet"
            cancelText="Hayır"
            onConfirm={() => handleOnClickDelete(data)}
          >
            <a>
              <DeleteOutlined style={{ color: "red", fontSize: "130%" }} />
            </a>
          </Popconfirm>
        ),
    },
  ];

  const onTabChange = (tabKey) => {
    setTableDataQueryOptions({
      ...tableDataQueryOptions,
      skip: 0,
      current: 1,
      activeTab: tabKey,
    });
    setTabKeyValue(tabKey);
  };

  const handleActivePassive = (id) => {
    RequestHandler.put(
      `/PosCollectionCommissionDefinition/SetActiveOpposite/${id}`
    ).then((response) => {
      if (response.success) {
        getTableData();
      }
    });
  };

  const openNotificationWithIcon = (type) => {
    notification[type]({
      message: "Uyarı",
      description: "Pasif olan komisyon tanımları güncellenemez.",
    });
  };

  const handleToggleAutoUpdate = async (id, value) => {
    const response = await RequestHandler.post(
      "/PosCollectionCommissionDefinition/ChangeAutoUpdateStatus",
      {
        id: id,
        isEnabledAutoUpdate: value,
      }
    );

    if (response?.success) {
      getTableData();
    }
  };

  return (
    <>
      <Row>
        <Col xs={16}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <BarsOutlined /> Banka Taksit Tanımları
          </p>
        </Col>
        <Col xs={8}>
          <Row justify="end" align="middle" style={{ paddingRight: 16 }}>
            <Button
              type="primary"
              onClick={() => {
                setAddFormVisibility(true);
              }}
              style={{ marginBottom: 0 }}
            >
              <PlusOutlined /> Tanım Ekle
            </Button>
          </Row>
        </Col>
      </Row>

      <PosCollectionCommissionDefinitionTableFilter
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        style={{ marginTop: 12, marginBottom: 12 }}
      />

      <Tabs
        defaultActiveKey={tableDataQueryOptions.activeTab}
        onChange={onTabChange}
      >
        <Tabs.TabPane tab="Tümü" key="0" />
        {tabData.map((tabItem) => (
          <Tabs.TabPane tab={tabItem.tabTitle} key={tabItem.key} />
        ))}
      </Tabs>

      <Row id="tableArea">
        <Col span={24}>
          <Table
            columns={columns}
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{ overflowX: "auto", maxHeight: "100%", width: "100%" }}
            rowKey="id"
            filterable={true}
            sortable={true}
            pageable={true}
            onChange={paging}
            pagination={{
              defaultPageSize: tableDataQueryOptions.take,
              pageSizeOptions: ["15", "25", "50", "100"],
              total: tableData.total,
              current: tableDataQueryOptions.current,
            }}
            dataSource={tableData.data}
            loading={tableData.loading}
            size="small"
          />

          {/* Tabkey değiştiğinde Param için veya hangi ödeme aracı olursa olsun
          onunla ilgili bilgilerin tutulacağı yeni tablo olması yerine direk Param yada hangi ödeme aracı ise onun bilgileri gelsin.
          Yukarıda tablo verilerinin dolduğu yere notlar ekledim. */}
        </Col>
      </Row>

      <Drawer
        id="addDrawer"
        title="Pos Komisyon Tanımı Ekle"
        bodyStyle={{ padding: 24 }}
        width={700}
        onClose={() => setAddFormVisibility(false)}
        visible={addFormVisibility}
      >
        <PosCollectionCommissionDefinitionAddForm
          onSuccess={onAddFormSuccess}
        />
      </Drawer>

      <Drawer
        id="updateDrawer"
        title="Pos Komisyon Tanımı Güncelle"
        bodyStyle={{ padding: 24 }}
        width={500}
        onClose={() => setUpdateFormVisibility(false)}
        visible={updateFormVisibility}
        destroyOnClose={true}
      >
        <PosCollectionCommissionDefinitionUpdateForm
          data={updateFormData}
          onSuccess={onUpdateFormSuccess}
        />
      </Drawer>
    </>
  );
};

export default PosCollectionCommissionDefinition;
